import api from '/src/api/api';

const actions = {
    storeImage: async (_, data) => (await api.storeImage.store(data)).data,
}

export default {
    namespaced: true,
    actions,
}